import { gql } from "@apollo/client";

export const SearchSystems = gql`
    query SearchSystems(
        $filter: SearchSystemFilter
        $query: SearchSystemQuery
        $pagination: Pagination
    ) {
        searchSystems(filter: $filter, query: $query) {
            total
            searchSystemResults(pagination: $pagination) {
                score
                system {
                    id
                    title
                    systemType
                    insert
                    update
                    client {
                        id
                        name
                    }
                    assetList {
                        total
                    }
                    installedBaseNode {
                        id
                        title
                        nodeType {
                            id
                            key
                        }
                        pathNodes {
                            id
                            title
                            nodeType {
                                id
                                key
                            }
                        }
                    }
                    iotConnection {
                        id
                        connectionStatus
                        gateway {
                            id
                            imei
                        }
                    }
                }
            }
        }
    }
`;
